import React from 'react';
import logo from '../../Mantle Logo.png';

/**
 * MantleBrand — the product/vendor logo (Mantle).
 *
 * The asset is black line-art on transparent, so it needs to be inverted to
 * white on dark surfaces:
 *   - onDark=true  → always inverted (for the always-dark sidebar footer).
 *   - onDark=false → adapts to theme (black in light mode, white in dark mode).
 *
 * `poweredBy` prepends a small "Powered by" label (used in the sidebar footer).
 */
export default function MantleBrand({ heightClass = 'h-8', poweredBy = false, onDark = false }) {
  const invertClass = onDark ? 'invert' : 'dark:invert';
  const labelColor = onDark
    ? 'text-slate-500'
    : 'text-slate-400 dark:text-slate-500';

  return (
    <div className="flex items-center gap-2 select-none" title="Powered by Mantle">
      {poweredBy && (
        <span className={`text-[10px] font-medium uppercase tracking-wider ${labelColor}`}>
          Powered by
        </span>
      )}
      <img
        src={logo}
        alt="Mantle"
        className={`${heightClass} w-auto object-contain ${invertClass}`}
      />
    </div>
  );
}
